(function () {
  function initSlideshow(root) {
    if (root.dataset.rrsInit) return;
    root.dataset.rrsInit = 'true';

    const dataScript = root.querySelector('[data-rrs-data]');
    let slides = [];
    try {
      slides = JSON.parse(dataScript.textContent);
    } catch (e) {
      slides = [];
    }
    if (!slides.length) return;

    const track = root.querySelector('[data-rrs-track]');
    const dotsWrap = root.querySelector('[data-rrs-dots]');
    const announce = root.querySelector('[data-rrs-announce]');
    const prevBtn = root.querySelector('[data-rrs-prev]');
    const nextBtn = root.querySelector('[data-rrs-next]');

    let current = 0;
    const autoplay = root.dataset.rrsAutoplay === 'true';
    const autoplaySpeed = parseInt(root.dataset.rrsSpeed, 10) || 5000;
    let timer = null;

    const slideEls = Array.from(track.querySelectorAll('.rr-slideshow__slide'));
    const dotEls = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.rr-slideshow__dot')) : [];

    function show(index) {
      current = (index + slides.length) % slides.length;
      slideEls.forEach((el, i) => el.classList.toggle('is-active', i === current));
      dotEls.forEach((el, i) => el.classList.toggle('is-active', i === current));
      if (announce) {
        announce.textContent = slides[current].name + ', slide ' + (current + 1) + ' of ' + slides.length;
      }
    }

    function next() { show(current + 1); resetTimer(); }
    function prev() { show(current - 1); resetTimer(); }

    function resetTimer() {
      if (!autoplay) return;
      if (timer) clearInterval(timer);
      timer = setInterval(() => show(current + 1), autoplaySpeed);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    dotEls.forEach((el, i) => el.addEventListener('click', () => { show(i); resetTimer(); }));

    root.addEventListener('mouseenter', () => { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', resetTimer);

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });

    let touchStartX = null;
    const stage = root.querySelector('[data-rrs-stage]');
    if (stage) {
      stage.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (touchStartX === null) return;
        const dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
        touchStartX = null;
      }, { passive: true });
    }

    show(0);
    resetTimer();
  }

  function initAll() {
    document.querySelectorAll('.rr-slideshow[data-rrs-stage-root]').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
